// extracted by mini-css-extract-plugin
export var centerText = "_5p-8";
export var container = "_5p-0";
export var doughnutContainer = "_5p-7";
export var legend = "_5p-a";
export var legendItemColorDisplay = "_5p-b";
export var legendItemLabel = "_5p-d";
export var legendItemValue = "_5p-c";
export var lg = "_5p-5";
export var maxWidth = "_5p-9";
export var md = "_5p-4";
export var responsive = "_5p-6";
export var sm = "_5p-3";
export var xs = "_5p-2";
export var xxs = "_5p-1";